var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrapper",attrs:{"id":"app"}},[_c('Sidebar'),_c('div',{attrs:{"id":"content"}},[_c('Header'),_c('router-view',{staticClass:"mainContent"}),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }